import { createSlice } from "@reduxjs/toolkit";
const getStringValue = (value) => {
  try {
    return value.toString();
  } catch (error) {
    return "";
  }
};
const initialState = {
  step: 1,
  multiMemberLLCData: {
    submissionUpdatesEmail: "",
    nameOfLLC: "",
    alreadyFiledLLC: "",
    mainBusinessAddressLine1: "",
    mainBusinessAddressLine2: "",
    mainBusinessCity: "",
    mainBusinessState: "",
    mainBusinessZipCode: "",
    primaryBusiness: "",
    noOfMembers: "",
    memberOneFirstName: "",
    memberOneInitialName: "",
    memberOneLastName: "",
    memberOneEmail: "",
    memberTwoFirstName: "",
    memberTwoInitialName: "",
    memberTwoLastName: "",
    memberTwoEmail: "",
    memberThreeFirstName: "",
    memberThreeInitialName: "",
    memberThreeLastName: "",
    memberThreeEmail: "",
    memberFourFirstName: "",
    memberFourInitialName: "",
    memberFourLastName: "",
    memberFourEmail: "",
    ownershipPercentage: "",
    memberOnePercentage: "",
    memberTwoPercentage: "",
    memberThreePercentage: "",
    memberFourPercentage: "",
    expectToAddNewMembers: "",
    expectationToAddNewMembers: "",
    memberOneContribution: [false, false, false, false, false],
    memberOneOther: "",
    memberOneCashContribution: "",
    memberOnePreExistingIntellectualProperty: "",
    memberOneOtherAssets: "",
    memberOneIsIntellectualProperty: "",
    memberOneIntellectualProperty: "",
    memberTwoContribution: [false, false, false, false, false],
    memberTwoOther: "",
    memberTwoCashContribution: "",
    memberTwoPreExistingIntellectualProperty: "",
    memberTwoOtherAssets: "",
    memberTwoIsIntellectualProperty: "",
    memberTwoIntellectualProperty: "",
    memberThreeContribution: [false, false, false, false, false],
    memberThreeOther: "",
    memberThreeCashContribution: "",
    memberThreePreExistingIntellectualProperty: "",
    memberThreeOtherAssets: "",
    memberThreeIsIntellectualProperty: "",
    memberThreeIntellectualProperty: "",
    memberFourContribution: [false, false, false, false, false],
    memberFourOther: "",
    memberFourCashContribution: "",
    memberFourPreExistingIntellectualProperty: "",
    memberFourOtherAssets: "",
    memberFourIsIntellectualProperty: "",
    memberFourIntellectualProperty: "",
    haveOneOrMoreMemberUnitsSubjectToVesting: "",
    membersHaveTheSameVestingSchedule: "",
    anyMemberHaveSomePortionOfUnitsVestedImmediately: "",
    portionOfTheMemberUnitsNotSubjectToVesting: "",
    percentageOfTheMemberUnitsNotSubjectToVesting: "",
    otherPercentageOfTheMemberUnitsNotSubjectToVesting: "",
    memberOneUnitsVestedImmediately: "",
    percentageOfMemberOneUnitsNotSubjectToVesting: "",
    otherPercentageOfMemberOneUnitsNotSubjectToVesting: "",
    memberTwoUnitsVestedImmediately: "",
    percentageOfMemberTwoUnitsNotSubjectToVesting: "",
    otherPercentageOfMemberTwoUnitsNotSubjectToVesting: "",
    memberThreeUnitsVestedImmediately: "",
    percentageOfMemberThreeUnitsNotSubjectToVesting: "",
    otherPercentageOfMemberThreeUnitsNotSubjectToVesting: "",
    memberFourUnitsVestedImmediately: "",
    percentageOfMemberFourUnitsNotSubjectToVesting: "",
    otherPercentageOfMemberFourUnitsNotSubjectToVesting: "",
    totalVestingTermForEachMember: "",
    otherTotalVestingTermForEachMember: "",
    totalVestingTermForEachMemberOne: "",
    otherTotalVestingTermForEachMemberOne: "",
    totalVestingTermForEachMemberTwo: "",
    otherTotalVestingTermForEachMemberTwo: "",
    totalVestingTermForEachMemberThree: "",
    otherTotalVestingTermForEachMemberThree: "",
    totalVestingTermForEachMemberFour: "",
    otherTotalVestingTermForEachMemberFour: "",
    vestingIncrementForAllMember: "",
    vestingIncrementForMemberOne: "",
    vestingIncrementForMemberTwo: "",
    vestingIncrementForMemberThree: "",
    vestingIncrementForMemberFour: "",
    /* <------------------------------Step2---------------------------> */
    allMemberAreParticipatingInTheManagement: "",
    nonManagingMemberStillBeProvidingServices: "",
    membersNotExpectedToHaveManagerAuthority: "",
    expectedTimeCommitment: [false, false, false, false],
    otherEachMemberExpectedTimeCommitment: "",
    memberGetSalary: "",
    otherMemberGetSalary: "",
    isCoMemberHaveApprovalRight: "",
    coMemberApprovalThreshold: "",
    coMemberApproval: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    otherCoMemberApprovalRequiredTo: "",
    limitOnTransactionsBeforeCoMemberApprovalIsRequired: "",
    limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired: "",
    isIncludeManagementDeadlockProcedures: "",
    managementDeadlockResolutionYouLike: "",
    deadlockVoteThreshold: "",
    shouldMemberAbleToBeRemoved: "",
    voteThresholdYouWantToRemoveForCauseOrIncapacity: "",
    otherVoteThresholdYouWantToRemoveForCauseOrIncapacity: "",
    voteThresholdYouWantToRemoveWithoutCause: "",
    otherVoteThresholdYouWantToRemoveWithoutCause: "",
    shouldTheMemberUnitSubjectToRepurchase: "",
    howLongOfNoticePeriod: "",
    otherHowLongOfNoticePeriod: "",
    isLikeToWaiveTheMemberFiduciaryDuties: "",
    isMemberSubjectToNonCompeteAgreement: "",
    isMemberSubjectToNonSolicitationAgreement: "",
    monthsAfterMemberNoLongerWorkingForNonCompete: "",
    otherMonthsAfterMemberNoLongerWorkingForNonCompete: "",
    monthsAfterMemberNoLongerWorkingForNonSolicitation: "",
    otherMonthsAfterMemberNoLongerWorkingForNonSolicitation: "",
    monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation: "",
    otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation: "",
    /* <-----------------------Step3----------------------------------------> */
    permittedTransfers: [false, false, false, false],
    toRepurchaseUnits: [false, false, false, false],
    otherPermittedTransfers: "",
    howRepurchasePriceBeDetermined: "",
    howRepurchasePriceBePaid: "",
    howLongTheRepaymentTerm: "",
    interestRate: "",
    otherInterestRate: "",
    offsetAgainstRepurchasePrice: "",
    preSetDamagesOffset: "",
    /* <-----------------------Step4----------------------------------------> */
    isLLCOperatingAgreementIncludeDefaultDisputeResolution: "",
    confirmTaxStatus: "",
    otherInformationNotes: "",
    isSubmitted: false,
    customerServiceId: "",
    id: "",
  },
};
export const multiMemberLLCSlice = createSlice({
  name: "multiMemberLLC",
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setmultiMemberLLCDataStep1: (state, action) => {
      if(!(action.payload.noOfMembers === "2" || action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberTwoFirstName=""
      }
      if(!(action.payload.noOfMembers === "2" || action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberTwoLastName =""
      }
      if(!(action.payload.noOfMembers === "2" || action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberTwoEmail=""
      }
      if(!(action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberThreeFirstName =""
      }
      if(!(action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberThreeLastName=""
      }
      if(!(action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberThreeEmail=""
      }
      if(!(action.payload.noOfMembers === "4"))
      {
        action.payload.memberFourFirstName=""
      }
      if(!(action.payload.noOfMembers === "4"))
      {
        action.payload.memberFourLastName=""
      }
      if(!(action.payload.noOfMembers === "4"))
      {
        action.payload.memberFourEmail =""
      }
      if(!(action.payload.expectToAddNewMembers === "true"))
      {
        action.payload.expectationToAddNewMembers =""
      }
      if(!( action.payload.memberOneContribution[4] === true))
      {
        action.payload.memberOneOther =""
      }
      if(!(action.payload.memberOneContribution[0] === true))
      {
        action.payload.memberOneCashContribution=""
      }
      if(!(action.payload.memberOneContribution[2] === true))
      {
        action.payload.memberOnePreExistingIntellectualProperty=""
      }
      if(!(action.payload.memberOneContribution[3] === true))
      {
        action.payload.memberOneOtherAssets=""
      }
      if(!(action.payload.memberOneIsIntellectualProperty === "true"))
      {
        action.payload.memberOneIntellectualProperty=""
      }
      if(!( action.payload.memberTwoContribution[4] === true))
      {
        action.payload.memberTwoOther=""
      }
      if(!(action.payload.memberTwoContribution[0] === true))
      {
        action.payload.memberTwoCashContribution=""
      }
      if(!(action.payload.memberTwoContribution[2] === true))
      {
        action.payload.memberTwoPreExistingIntellectualProperty=""
      }
      if(!(action.payload.memberTwoContribution[3] === true))
      {
        action.payload.memberTwoOtherAssets=""
      }
      if(!(action.payload.memberTwoIsIntellectualProperty === "true"))
      {
        action.payload.memberTwoIntellectualProperty=""
      }
      if(!(action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberThreeContribution =[false,false,false,false,false]
      }
      if(!(
        action.payload.memberThreeContribution[4] === true &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreeOther=""
      }
      if(!(action.payload.memberThreeContribution[0] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreeCashContribution=""
      }
      if(!( action.payload.memberThreeContribution[2] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreePreExistingIntellectualProperty=""
      }
      if(!( action.payload.memberThreeContribution[3] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreeOtherAssets=""
      }
      if(!(action.payload.noOfMembers==="4"||action.payload.noOfMembers==="3"))
      {
        action.payload.memberThreeIsIntellectualProperty=""
      }
      if(!(action.payload.memberThreeIsIntellectualProperty === "true" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreeIntellectualProperty=""
      }
      if(!(action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4"))
      {
        action.payload.memberFourContribution =[false,false,false,false,false]
      }
      if(!(action.payload.memberFourContribution[4] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberFourOther=""
      }
      if(!(action.payload.memberFourContribution[0] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberFourCashContribution=""
      }
      if(!(action.payload.memberFourContribution[2] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberFourPreExistingIntellectualProperty=""
      }
      if(!(action.payload.memberFourContribution[3] === true &&
        (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberFourOtherAssets=""
      }
      if(!(action.payload.noOfMembers==="4"))
      {
        action.payload.memberFourIsIntellectualProperty=""
      }
      if(!(action.payload.memberFourIsIntellectualProperty === "true" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberFourIntellectualProperty=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true"))
      {
        action.payload.membersHaveTheSameVestingSchedule=""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false"))
      {
        action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "true"))
      {
        action.payload.portionOfTheMemberUnitsNotSubjectToVesting =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "true" &&
      action.payload.portionOfTheMemberUnitsNotSubjectToVesting === "true"))
      {
        action.payload.percentageOfTheMemberUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "true" &&
      action.payload.portionOfTheMemberUnitsNotSubjectToVesting === "true" &&
      action.payload.percentageOfTheMemberUnitsNotSubjectToVesting === "Other"))
      {
        action.payload.otherPercentageOfTheMemberUnitsNotSubjectToVesting =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.alreadyFiledLLC === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true"))
      {
        action.payload.memberOneUnitsVestedImmediately=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.alreadyFiledLLC === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberOneUnitsVestedImmediately === "true"))
      {
        action.payload.percentageOfMemberOneUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.alreadyFiledLLC === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberOneUnitsVestedImmediately === "true" &&
      action.payload.percentageOfMemberOneUnitsNotSubjectToVesting === "Other"))
      {
        action.payload.otherPercentageOfMemberOneUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true"))
      {
        action.payload.memberTwoUnitsVestedImmediately=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberTwoUnitsVestedImmediately === "true"))
      {
        action.payload.percentageOfMemberTwoUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberTwoUnitsVestedImmediately === "true" &&
      action.payload.percentageOfMemberTwoUnitsNotSubjectToVesting === "Other"))
      {
        action.payload.otherPercentageOfMemberTwoUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreeUnitsVestedImmediately=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberThreeUnitsVestedImmediately === "true" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberThreeUnitsVestedImmediately === "true" &&
      action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting === "Other" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.otherPercentageOfMemberThreeUnitsNotSubjectToVesting=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.noOfMembers === "4"))
      {
        action.payload.memberFourUnitsVestedImmediately=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberFourUnitsVestedImmediately === "true" &&
      action.payload.noOfMembers === "4"))
      {
        action.payload.percentageOfMemberFourUnitsNotSubjectToVesting =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberFourUnitsVestedImmediately === "true" &&
      action.payload.percentageOfMemberFourUnitsNotSubjectToVesting === "Other" &&
      action.payload.noOfMembers === "4"))
      {
        action.payload.otherPercentageOfMemberFourUnitsNotSubjectToVesting =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.memberThreeUnitsVestedImmediately =""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberThreeUnitsVestedImmediately === "true" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
      action.payload.memberThreeUnitsVestedImmediately === "true" &&
      action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting === "Other" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.otherPercentageOfMemberThreeUnitsNotSubjectToVesting =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "true"))
      {
        action.payload.totalVestingTermForEachMember=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "true" &&
      action.payload.totalVestingTermForEachMember === "Other"))
      {
        action.payload.otherTotalVestingTermForEachMember =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false"))
      {
        action.payload.totalVestingTermForEachMemberOne =""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberOne === "Other"))
      {
        action.payload.otherTotalVestingTermForEachMemberOne=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false"))
      {
        action.payload.totalVestingTermForEachMemberTwo=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberTwo === "Other"))
      {
        action.payload.otherTotalVestingTermForEachMemberTwo=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.totalVestingTermForEachMemberThree=""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberThree === "Other" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.otherTotalVestingTermForEachMemberThree=""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.noOfMembers === "4"))
      {
        action.payload.totalVestingTermForEachMemberFour=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberFour === "Other" &&
      action.payload.noOfMembers === "4"))
      {
        action.payload.otherTotalVestingTermForEachMemberFour =""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "true"))
      {
        action.payload.vestingIncrementForAllMember=""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false"))
      {
        action.payload.vestingIncrementForMemberOne=""
      }
      if(!( action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberTwo !== "No vesting for this member"))
      {
        action.payload.vestingIncrementForMemberTwo=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberThree !== "No vesting for this member" &&
      (action.payload.noOfMembers === "3" || action.payload.noOfMembers === "4")))
      {
        action.payload.vestingIncrementForMemberThree=""
      }
      if(!(action.payload.haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
      action.payload.membersHaveTheSameVestingSchedule === "false" &&
      action.payload.totalVestingTermForEachMemberFour !== "No vesting for this member" &&
      action.payload.noOfMembers === "4"))
      {
        action.payload.vestingIncrementForMemberFour=""
      }
      state.multiMemberLLCData = {
        ...state.multiMemberLLCData,
        submissionUpdatesEmail: action.payload.submissionUpdatesEmail,
        nameOfLLC: action.payload.nameOfLLC,
        alreadyFiledLLC: action.payload.alreadyFiledLLC,
        mainBusinessAddressLine1: action.payload.mainBusinessAddressLine1,
        mainBusinessAddressLine2: action.payload.mainBusinessAddressLine2,
        mainBusinessCity: action.payload.mainBusinessCity,
        mainBusinessState: action.payload.mainBusinessState,
        mainBusinessZipCode: action.payload.mainBusinessZipCode,
        primaryBusiness: action.payload.primaryBusiness,
        noOfMembers: action.payload.noOfMembers,
        memberOneFirstName: action.payload.memberOneFirstName,
        memberOneInitialName: action.payload.memberOneInitialName,
        memberOneLastName: action.payload.memberOneLastName,
        memberOneEmail: action.payload.memberOneEmail,
        memberTwoFirstName: action.payload.memberTwoFirstName,
        memberTwoInitialName: action.payload.memberTwoInitialName,
        memberTwoLastName: action.payload.memberTwoLastName,
        memberTwoEmail: action.payload.memberTwoEmail,
        memberThreeFirstName: action.payload.memberThreeFirstName,
        memberThreeInitialName: action.payload.memberThreeInitialName,
        memberThreeLastName: action.payload.memberThreeLastName,
        memberThreeEmail: action.payload.memberThreeEmail,
        memberFourFirstName: action.payload.memberFourFirstName,
        memberFourInitialName: action.payload.memberFourInitialName,
        memberFourLastName: action.payload.memberFourLastName,
        memberFourEmail: action.payload.memberFourEmail,
        ownershipPercentage: action.payload.ownershipPercentage,
        memberOnePercentage: action.payload.memberOnePercentage,
        memberTwoPercentage: action.payload.memberTwoPercentage,
        memberThreePercentage: action.payload.memberThreePercentage,
        memberFourPercentage: action.payload.memberThreePercentage,
        expectToAddNewMembers: action.payload.expectToAddNewMembers,
        expectationToAddNewMembers: action.payload.expectationToAddNewMembers,
        memberOneContribution: [
          action.payload.memberOneContribution[0],
          action.payload.memberOneContribution[1],
          action.payload.memberOneContribution[2],
          action.payload.memberOneContribution[3],
          action.payload.memberOneContribution[4],
        ],
        memberOneOther: action.payload.memberOneOther,
        memberOneCashContribution: action.payload.memberOneCashContribution,
        memberOnePreExistingIntellectualProperty:
          action.payload.memberOnePreExistingIntellectualProperty,
        memberOneOtherAssets: action.payload.memberOneOtherAssets,
        memberOneIsIntellectualProperty:
          action.payload.memberOneIsIntellectualProperty,
        memberOneIntellectualProperty:
          action.payload.memberOneIntellectualProperty,
        memberTwoContribution: [
          action.payload.memberTwoContribution[0],
          action.payload.memberTwoContribution[1],
          action.payload.memberTwoContribution[2],
          action.payload.memberTwoContribution[3],
          action.payload.memberTwoContribution[4],
        ],
        memberTwoOther: action.payload.memberTwoOther,
        memberTwoCashContribution: action.payload.memberTwoCashContribution,
        memberTwoPreExistingIntellectualProperty:
          action.payload.memberTwoPreExistingIntellectualProperty,
        memberTwoOtherAssets: action.payload.memberTwoOtherAssets,
        memberTwoIsIntellectualProperty:
          action.payload.memberTwoIsIntellectualProperty,
        memberTwoIntellectualProperty:
          action.payload.memberTwoIntellectualProperty,
        memberThreeContribution: [
          action.payload.memberThreeContribution[0],
          action.payload.memberThreeContribution[1],
          action.payload.memberThreeContribution[2],
          action.payload.memberThreeContribution[3],
          action.payload.memberThreeContribution[4],
        ],
        memberThreeOther: action.payload.memberThreeOther,
        memberThreeCashContribution: action.payload.memberThreeCashContribution,
        memberThreePreExistingIntellectualProperty:
          action.payload.memberThreePreExistingIntellectualProperty,
        memberThreeOtherAssets: action.payload.memberThreeOtherAssets,
        memberThreeIsIntellectualProperty:
          action.payload.memberThreeIsIntellectualProperty,
        memberThreeIntellectualProperty:
          action.payload.memberThreeIntellectualProperty,
        memberFourContribution: [
          action.payload.memberFourContribution[0],
          action.payload.memberFourContribution[1],
          action.payload.memberFourContribution[2],
          action.payload.memberFourContribution[3],
          action.payload.memberFourContribution[4],
        ],
        memberFourOther: action.payload.memberFourOther,
        memberFourCashContribution: action.payload.memberFourCashContribution,
        memberFourPreExistingIntellectualProperty:
          action.payload.memberFourPreExistingIntellectualProperty,
        memberFourOtherAssets: action.payload.memberFourOtherAssets,
        memberFourIsIntellectualProperty:
          action.payload.memberFourIsIntellectualProperty,
        memberFourIntellectualProperty:
          action.payload.memberFourIntellectualProperty,
        haveOneOrMoreMemberUnitsSubjectToVesting:
          action.payload.haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule:
          action.payload.membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately:
          action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately,
        portionOfTheMemberUnitsNotSubjectToVesting:
          action.payload.portionOfTheMemberUnitsNotSubjectToVesting,
        percentageOfTheMemberUnitsNotSubjectToVesting:
          action.payload.percentageOfTheMemberUnitsNotSubjectToVesting,
        otherPercentageOfTheMemberUnitsNotSubjectToVesting:
          action.payload.otherPercentageOfTheMemberUnitsNotSubjectToVesting,

        memberOneUnitsVestedImmediately:
          action.payload.memberOneUnitsVestedImmediately,
        percentageOfMemberOneUnitsNotSubjectToVesting:
          action.payload.percentageOfMemberOneUnitsNotSubjectToVesting,
        otherPercentageOfMemberOneUnitsNotSubjectToVesting:
          action.payload.otherPercentageOfMemberOneUnitsNotSubjectToVesting,

        memberTwoUnitsVestedImmediately:
          action.payload.memberTwoUnitsVestedImmediately,
        percentageOfMemberTwoUnitsNotSubjectToVesting:
          action.payload.percentageOfMemberTwoUnitsNotSubjectToVesting,
        otherPercentageOfMemberTwoUnitsNotSubjectToVesting:
          action.payload.otherPercentageOfMemberTwoUnitsNotSubjectToVesting,

        memberThreeUnitsVestedImmediately:
          action.payload.memberThreeUnitsVestedImmediately,
        percentageOfMemberThreeUnitsNotSubjectToVesting:
          action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting,
        otherPercentageOfMemberThreeUnitsNotSubjectToVesting:
          action.payload.otherPercentageOfMemberThreeUnitsNotSubjectToVesting,

        memberFourUnitsVestedImmediately:
          action.payload.memberFourUnitsVestedImmediately,
        percentageOfMemberFourUnitsNotSubjectToVesting:
          action.payload.percentageOfMemberFourUnitsNotSubjectToVesting,
        otherPercentageOfMemberFourUnitsNotSubjectToVesting:
          action.payload.otherPercentageOfMemberFourUnitsNotSubjectToVesting,

        totalVestingTermForEachMember:
          action.payload.totalVestingTermForEachMember,
        otherTotalVestingTermForEachMember:
          action.payload.otherTotalVestingTermForEachMember,

        totalVestingTermForEachMemberOne:
          action.payload.totalVestingTermForEachMemberOne,
        otherTotalVestingTermForEachMemberOne:
          action.payload.otherTotalVestingTermForEachMemberOne,
        totalVestingTermForEachMemberTwo:
          action.payload.totalVestingTermForEachMemberTwo,
        otherTotalVestingTermForEachMemberTwo:
          action.payload.otherTotalVestingTermForEachMemberTwo,
        totalVestingTermForEachMemberThree:
          action.payload.totalVestingTermForEachMemberThree,
        otherTotalVestingTermForEachMemberThree:
          action.payload.otherTotalVestingTermForEachMemberThree,
        totalVestingTermForEachMemberFour:
          action.payload.totalVestingTermForEachMemberFour,
        otherTotalVestingTermForEachMemberFour:
          action.payload.otherTotalVestingTermForEachMemberFour,

        vestingIncrementForAllMember:
          action.payload.vestingIncrementForAllMember,
        vestingIncrementForMemberOne:
          action.payload.vestingIncrementForMemberOne,
        vestingIncrementForMemberTwo:
          action.payload.vestingIncrementForMemberTwo,
        vestingIncrementForMemberThree:
          action.payload.vestingIncrementForMemberThree,
        vestingIncrementForMemberFour:
          action.payload.vestingIncrementForMemberFour,
      };
    },
    setmultiMemberLLCDataStep2: (state, action) => {
      if (
        !(action.payload.allMemberAreParticipatingInTheManagement === "false")
      ) {
        action.payload.nonManagingMemberStillBeProvidingServices = "";
      }
      if (
        !(action.payload.allMemberAreParticipatingInTheManagement === "false")
      ) {
        action.payload.membersNotExpectedToHaveManagerAuthority = "";
      }
      if (!(action.payload.expectedTimeCommitment[3] === true)) {
        action.payload.otherEachMemberExpectedTimeCommitment = "";
      }
      if (!(action.payload.memberGetSalary === "3")) {
        action.payload.otherMemberGetSalary = "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true") ||
          action.payload.allMemberAreParticipatingInTheManagement === "true"
        )
      ) {
        action.payload.isCoMemberHaveApprovalRight = "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true") ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true")
        )
      ) {
        action.payload.coMemberApprovalThreshold = "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true") ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true")
        )
      ) {
        action.payload.coMemberApproval = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ];
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.coMemberApproval[15] === true) ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.coMemberApproval[15] === true)
        )
      ) {
        action.payload.otherCoMemberApprovalRequiredTo = "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.coMemberApproval[0] === true) ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.coMemberApproval[0] === true)
        )
      ) {
        action.payload.limitOnTransactionsBeforeCoMemberApprovalIsRequired = "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.coMemberApproval[1] === true) ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.coMemberApproval[1] === true)
        )
      ) {
        action.payload.limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired =
          "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true") ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true")
        )
      ) {
        action.payload.isIncludeManagementDeadlockProcedures = "";
      }
      if (
        !(
          (action.payload.allMemberAreParticipatingInTheManagement ===
            "false" &&
            action.payload.nonManagingMemberStillBeProvidingServices ===
              "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.isIncludeManagementDeadlockProcedures === "true" &&
            action.payload.managementDeadlockResolutionYouLike === "2") ||
          (action.payload.allMemberAreParticipatingInTheManagement === "true" &&
            action.payload.isCoMemberHaveApprovalRight === "true" &&
            action.payload.isIncludeManagementDeadlockProcedures === "true" &&
            action.payload.managementDeadlockResolutionYouLike === "2")
        )
      ) {
        action.payload.deadlockVoteThreshold = "";
      }
      if (!(action.payload.shouldMemberAbleToBeRemoved === "1")) {
        action.payload.voteThresholdYouWantToRemoveForCauseOrIncapacity = "";
      }
      if (
        !(
          action.payload.shouldMemberAbleToBeRemoved === "1" &&
          action.payload.voteThresholdYouWantToRemoveForCauseOrIncapacity ===
            "6"
        )
      ) {
        action.payload.otherVoteThresholdYouWantToRemoveForCauseOrIncapacity =
          "";
      }
      if (!(action.payload.shouldMemberAbleToBeRemoved === "2")) {
        action.payload.voteThresholdYouWantToRemoveWithoutCause = "";
      }
      if (
        !(
          action.payload.shouldMemberAbleToBeRemoved === "2" &&
          action.payload.voteThresholdYouWantToRemoveWithoutCause === "5"
        )
      ) {
        action.payload.otherVoteThresholdYouWantToRemoveWithoutCause = "";
      }
      if (!(action.payload.howLongOfNoticePeriod === "5")) {
        action.payload.otherHowLongOfNoticePeriod = "";
      }
      if (
        !(
          action.payload.isMemberSubjectToNonCompeteAgreement === "true" &&
          action.payload.isMemberSubjectToNonSolicitationAgreement === "false"
        )
      ) {
        action.payload.monthsAfterMemberNoLongerWorkingForNonCompete = "";
      }
      if (
        !(
          action.payload.isMemberSubjectToNonCompeteAgreement === "true" &&
          action.payload.isMemberSubjectToNonSolicitationAgreement ===
            "false" &&
          action.payload.monthsAfterMemberNoLongerWorkingForNonCompete === "4"
        )
      ) {
        action.payload.otherMonthsAfterMemberNoLongerWorkingForNonCompete = "";
      }
      if (
        !(
          action.payload.isMemberSubjectToNonCompeteAgreement === "false" &&
          action.payload.isMemberSubjectToNonSolicitationAgreement === "true"
        )
      ) {
        action.payload.monthsAfterMemberNoLongerWorkingForNonSolicitation = "";
      }
      if (
        !(
          action.payload.isMemberSubjectToNonCompeteAgreement === "false" &&
          action.payload.isMemberSubjectToNonSolicitationAgreement === "true" &&
          action.payload.monthsAfterMemberNoLongerWorkingForNonSolicitation ===
            "4"
        )
      ) {
        action.payload.otherMonthsAfterMemberNoLongerWorkingForNonSolicitation =
          "";
      }
      if (
        !(
          action.payload.isMemberSubjectToNonCompeteAgreement === "true" &&
          action.payload.isMemberSubjectToNonSolicitationAgreement === "true"
        )
      ) {
        action.payload.monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation =
          "";
      }
      if (
        !(
          action.payload.isMemberSubjectToNonCompeteAgreement === "true" &&
          action.payload.isMemberSubjectToNonSolicitationAgreement === "true" &&
          action.payload
            .monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation ===
            "4"
        )
      ) {
        action.payload.otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation =
          "";
      }
      state.multiMemberLLCData = {
        ...state.multiMemberLLCData,
        allMemberAreParticipatingInTheManagement:
          action.payload.allMemberAreParticipatingInTheManagement,
        nonManagingMemberStillBeProvidingServices:
          action.payload.nonManagingMemberStillBeProvidingServices,
        membersNotExpectedToHaveManagerAuthority:
          action.payload.membersNotExpectedToHaveManagerAuthority,
        expectedTimeCommitment: [
          action.payload.expectedTimeCommitment[0],
          action.payload.expectedTimeCommitment[1],
          action.payload.expectedTimeCommitment[2],
          action.payload.expectedTimeCommitment[3],
        ],
        otherEachMemberExpectedTimeCommitment:
          action.payload.otherEachMemberExpectedTimeCommitment,
        memberGetSalary: action.payload.memberGetSalary,
        otherMemberGetSalary: action.payload.otherMemberGetSalary,
        isCoMemberHaveApprovalRight: action.payload.isCoMemberHaveApprovalRight,
        coMemberApprovalThreshold: action.payload.coMemberApprovalThreshold,
        coMemberApproval: [
          action.payload.coMemberApproval[0],
          action.payload.coMemberApproval[1],
          action.payload.coMemberApproval[2],
          action.payload.coMemberApproval[3],
          action.payload.coMemberApproval[4],
          action.payload.coMemberApproval[5],
          action.payload.coMemberApproval[6],
          action.payload.coMemberApproval[7],
          action.payload.coMemberApproval[8],
          action.payload.coMemberApproval[9],
          action.payload.coMemberApproval[10],
          action.payload.coMemberApproval[11],
          action.payload.coMemberApproval[12],
          action.payload.coMemberApproval[13],
          action.payload.coMemberApproval[14],
          action.payload.coMemberApproval[15],
        ],
        otherCoMemberApprovalRequiredTo:
          action.payload.otherCoMemberApprovalRequiredTo,
        limitOnTransactionsBeforeCoMemberApprovalIsRequired:
          action.payload.limitOnTransactionsBeforeCoMemberApprovalIsRequired,
        limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired:
          action.payload
            .limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired,
        isIncludeManagementDeadlockProcedures:
          action.payload.isIncludeManagementDeadlockProcedures,
        managementDeadlockResolutionYouLike:
          action.payload.managementDeadlockResolutionYouLike,
        deadlockVoteThreshold: action.payload.deadlockVoteThreshold,
        shouldMemberAbleToBeRemoved: action.payload.shouldMemberAbleToBeRemoved,
        voteThresholdYouWantToRemoveForCauseOrIncapacity:
          action.payload.voteThresholdYouWantToRemoveForCauseOrIncapacity,
        otherVoteThresholdYouWantToRemoveForCauseOrIncapacity:
          action.payload.otherVoteThresholdYouWantToRemoveForCauseOrIncapacity,
        voteThresholdYouWantToRemoveWithoutCause:
          action.payload.voteThresholdYouWantToRemoveWithoutCause,
        otherVoteThresholdYouWantToRemoveWithoutCause:
          action.payload.otherVoteThresholdYouWantToRemoveWithoutCause,
        shouldTheMemberUnitSubjectToRepurchase:
          action.payload.shouldTheMemberUnitSubjectToRepurchase,
        howLongOfNoticePeriod: action.payload.howLongOfNoticePeriod,
        otherHowLongOfNoticePeriod: action.payload.otherHowLongOfNoticePeriod,
        isLikeToWaiveTheMemberFiduciaryDuties:
          action.payload.isLikeToWaiveTheMemberFiduciaryDuties,
        isMemberSubjectToNonCompeteAgreement:
          action.payload.isMemberSubjectToNonCompeteAgreement,
        isMemberSubjectToNonSolicitationAgreement:
          action.payload.isMemberSubjectToNonSolicitationAgreement,
        monthsAfterMemberNoLongerWorkingForNonCompete:
          action.payload.monthsAfterMemberNoLongerWorkingForNonCompete,
        otherMonthsAfterMemberNoLongerWorkingForNonCompete:
          action.payload.otherMonthsAfterMemberNoLongerWorkingForNonCompete,
        monthsAfterMemberNoLongerWorkingForNonSolicitation:
          action.payload.monthsAfterMemberNoLongerWorkingForNonSolicitation,
        otherMonthsAfterMemberNoLongerWorkingForNonSolicitation:
          action.payload
            .otherMonthsAfterMemberNoLongerWorkingForNonSolicitation,
        monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
          action.payload
            .monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation,
        otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
          action.payload
            .otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation,
      };
      console.log(state.multiMemberLLCData);
    },
    setmultiMemberLLCDataStep3: (state, action) => {
      if (!(action.payload.permittedTransfers[3] === true)) {
        action.payload.otherPermittedTransfers = "";
      }
      if (
        !(
          action.payload.howRepurchasePriceBePaid === "3" ||
          action.payload.howRepurchasePriceBePaid === "2"
        )
      ) {
        action.payload.howLongTheRepaymentTerm = "";
      }
      if (
        !(
          action.payload.howRepurchasePriceBePaid === "3" ||
          action.payload.howRepurchasePriceBePaid === "2"
        )
      ) {
        action.payload.interestRate = "";
      }
      if (!(action.payload.interestRate === "2")) {
        action.payload.otherInterestRate = "";
      }
      if (!(action.payload.offsetAgainstRepurchasePrice === "true")) {
        action.payload.preSetDamagesOffset = "";
      }
      state.multiMemberLLCData = {
        ...state.multiMemberLLCData,
        permittedTransfers: [
          action.payload.permittedTransfers[0],
          action.payload.permittedTransfers[1],
          action.payload.permittedTransfers[2],
          action.payload.permittedTransfers[3],
        ],
        toRepurchaseUnits: [
          action.payload.toRepurchaseUnits[0],
          action.payload.toRepurchaseUnits[1],
          action.payload.toRepurchaseUnits[2],
          action.payload.toRepurchaseUnits[3],
        ],
        otherPermittedTransfers: action.payload.otherPermittedTransfers,
        howRepurchasePriceBeDetermined:
          action.payload.howRepurchasePriceBeDetermined,
        howRepurchasePriceBePaid: action.payload.howRepurchasePriceBePaid,
        howLongTheRepaymentTerm: action.payload.howLongTheRepaymentTerm,
        interestRate: action.payload.interestRate,
        otherInterestRate: action.payload.otherInterestRate,
        offsetAgainstRepurchasePrice:
          action.payload.offsetAgainstRepurchasePrice,
        preSetDamagesOffset: action.payload.preSetDamagesOffset,
      };
      console.log(state.multiMemberLLCData);
    },
    setmultiMemberLLCDataStep4: (state, action) => {
      state.multiMemberLLCData = {
        ...state.multiMemberLLCData,
        isLLCOperatingAgreementIncludeDefaultDisputeResolution:
          action.payload.isLLCOperatingAgreementIncludeDefaultDisputeResolution,
        confirmTaxStatus: action.payload.confirmTaxStatus,
        otherInformationNotes: action.payload.otherInformationNotes,
      };
      console.log(state.multiMemberLLCData);
    },
    setCustomerServiceId: (state, action) => {
      state.multiMemberLLCData = {
        ...state.multiMemberLLCData,
        customerServiceId: action.payload,
      };
    },
    setmultiMemberLLCData: (state, action) => {
      /* state.multiMemberLLCData={
        submissionUpdatesEmail: action.payload.submissionUpdatesEmail.toString(),
        nameOfLLC: action.payload.nameOfLLC.toString(),
        alreadyFiledLLC: action.payload.alreadyFiledLLC.toString(),
        mainBusinessAddressLine1: action.payload.mainBusinessAddressLine1.toString(),
        mainBusinessAddressLine2: action.payload.mainBusinessAddressLine2.toString(),
        mainBusinessCity: action.payload.mainBusinessCity.toString(),
        mainBusinessState: action.payload.mainBusinessState.toString(),
        mainBusinessZipCode: action.payload.mainBusinessZipCode.toString(),
        primaryBusiness: action.payload.primaryBusiness.toString(),
        noOfMembers: action.payload.noOfMembers.toString(),
        memberOneFirstName: action.payload.memberOneFirstName.toString(),
        memberOneInitialName: action.payload.memberOneInitialName.toString(),
        memberOneLastName: action.payload.memberOneLastName.toString(),
        memberOneEmail: action.payload.memberOneEmail.toString(),
        memberTwoFirstName: action.payload.memberTwoFirstName.toString(),
        memberTwoInitialName: action.payload.memberTwoInitialName.toString(),
        memberTwoLastName: action.payload.memberTwoLastName.toString(),
        memberTwoEmail: action.payload.memberTwoEmail.toString(),
        memberThreeFirstName: action.payload.memberThreeFirstName.toString(),
        memberThreeInitialName: action.payload.memberThreeInitialName.toString(),
        memberThreeLastName: action.payload.memberThreeLastName.toString(),
        memberThreeEmail: action.payload.memberThreeEmail.toString(),
        memberFourFirstName: action.payload.memberFourFirstName.toString(),
        memberFourInitialName: action.payload.memberFourInitialName.toString(),
        memberFourLastName: action.payload.memberFourLastName.toString(),
        memberFourEmail: action.payload.memberFourEmail.toString(),
        ownershipPercentage: action.payload.ownershipPercentage.toString(),
        memberOnePercentage: action.payload.memberOnePercentage.toString(),
        memberTwoPercentage: action.payload.memberTwoPercentage.toString(),
        memberThreePercentage: action.payload.memberThreePercentage.toString(),
        memberFourPercentage: action.payload.memberFourPercentage.toString(),
        expectToAddNewMembers: action.payload.expectToAddNewMembers.toString(),
        expectationToAddNewMembers: action.payload.expectationToAddNewMembers.toString(),
        memberOneContribution: [action.payload.memberOneIsCash, action.payload.memberOneIsService, action.payload.memberOneIsPreExistingIntellectualProperty, action.payload.memberOneIsOtherAssets, action.payload.memberOneIsOther],
        memberOneOther: action.payload.memberOneOther.toString(),
        memberOneCashContribution: action.payload.memberOneCashContribution.toString(),
        memberOnePreExistingIntellectualProperty: action.payload.memberOnePreExistingIntellectualProperty.toString(),
        memberOneOtherAssets: action.payload.memberOneOtherAssets.toString(),
        memberOneIsIntellectualProperty: action.payload.memberOneIsIntellectualProperty.toString(),
        memberOneIntellectualProperty: action.payload.memberOneIntellectualProperty.toString(),
        memberTwoContribution: [action.payload.memberTwoIsCash, action.payload.memberTwoIsService, action.payload.memberTwoIsPreExistingIntellectualProperty, action.payload.memberTwoIsOtherAssets, action.payload.memberTwoIsOther],
        memberTwoOther: action.payload.memberTwoOther.toString(),
        memberTwoCashContribution: action.payload.memberTwoCashContribution.toString(),
        memberTwoPreExistingIntellectualProperty: action.payload.memberTwoPreExistingIntellectualProperty.toString(),
        memberTwoOtherAssets: action.payload.memberTwoOtherAssets.toString(),
        memberTwoIsIntellectualProperty: action.payload.memberTwoIsIntellectualProperty.toString(),
        memberTwoIntellectualProperty: action.payload.memberTwoIntellectualProperty.toString(),
        memberThreeContribution: [action.payload.memberThreeIsCash, action.payload.memberThreeIsService, action.payload.memberThreeIsPreExistingIntellectualProperty, action.payload.memberThreeIsOtherAssets, action.payload.memberThreeIsOther],
        memberThreeOther: action.payload.memberThreeOther.toString(),
        memberThreeCashContribution: action.payload.memberThreeCashContribution.toString(),
        memberThreePreExistingIntellectualProperty: action.payload.memberThreePreExistingIntellectualProperty.toString(),
        memberThreeOtherAssets: action.payload.memberThreeOtherAssets.toString(),
        memberThreeIsIntellectualProperty: action.payload.memberThreeIsIntellectualProperty.toString(),
        memberThreeIntellectualProperty: action.payload.memberThreeIntellectualProperty.toString(),
        memberFourContribution: [action.payload.memberFourIsCash, action.payload.memberFourIsService, action.payload.memberFourIsPreExistingIntellectualProperty, action.payload.memberFourIsOtherAssets, action.payload.memberFourIsOther],
        memberFourOther: action.payload.memberFourOther.toString(),
        memberFourCashContribution: action.payload.memberFourCashContribution.toString(),
        memberFourPreExistingIntellectualProperty: action.payload.memberFourPreExistingIntellectualProperty.toString(),
        memberFourOtherAssets: action.payload.memberFourOtherAssets.toString(),
        memberFourIsIntellectualProperty: action.payload.memberFourIsIntellectualProperty.toString(),
        memberFourIntellectualProperty: action.payload.memberFourIntellectualProperty.toString(),
        haveOneOrMoreMemberUnitsSubjectToVesting: action.payload.haveOneOrMoreMemberUnitsSubjectToVesting.toString(),
        membersHaveTheSameVestingSchedule: action.payload.membersHaveTheSameVestingSchedule.toString(),
        anyMemberHaveSomePortionOfUnitsVestedImmediately: action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately.toString(),
        portionOfTheMemberUnitsNotSubjectToVesting: action.payload.portionOfTheMemberUnitsNotSubjectToVesting.toString(),
        percentageOfTheMemberUnitsNotSubjectToVesting: action.payload.percentageOfTheMemberUnitsNotSubjectToVesting.toString(),
        otherPercentageOfTheMemberUnitsNotSubjectToVesting: action.payload.otherPercentageOfTheMemberUnitsNotSubjectToVesting.toString(),
        memberOneUnitsVestedImmediately: action.payload.memberOneUnitsVestedImmediately.toString(),
        percentageOfMemberOneUnitsNotSubjectToVesting: action.payload.percentageOfMemberOneUnitsNotSubjectToVesting.toString(),
        otherPercentageOfMemberOneUnitsNotSubjectToVesting: action.payload.otherPercentageOfMemberOneUnitsNotSubjectToVesting.toString(),
        memberTwoUnitsVestedImmediately: action.payload.memberTwoUnitsVestedImmediately.toString(),
        percentageOfMemberTwoUnitsNotSubjectToVesting: action.payload.percentageOfMemberTwoUnitsNotSubjectToVesting.toString(),
        otherPercentageOfMemberTwoUnitsNotSubjectToVesting: action.payload.otherPercentageOfMemberTwoUnitsNotSubjectToVesting.toString(),
        memberThreeUnitsVestedImmediately: action.payload.memberThreeUnitsVestedImmediately.toString(),
        percentageOfMemberThreeUnitsNotSubjectToVesting: action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting.toString(),
        otherPercentageOfMemberThreeUnitsNotSubjectToVesting: action.payload.otherPercentageOfMemberThreeUnitsNotSubjectToVesting.toString(),
        memberFourUnitsVestedImmediately: action.payload.memberFourUnitsVestedImmediately.toString(),
        percentageOfMemberFourUnitsNotSubjectToVesting: action.payload.percentageOfMemberFourUnitsNotSubjectToVesting.toString(),
        otherPercentageOfMemberFourUnitsNotSubjectToVesting: action.payload.otherPercentageOfMemberFourUnitsNotSubjectToVesting.toString(),
        totalVestingTermForEachMember: action.payload.totalVestingTermForEachMember.toString(),
        otherTotalVestingTermForEachMember: action.payload.otherTotalVestingTermForEachMember.toString(),
        totalVestingTermForEachMemberOne: action.payload.totalVestingTermForEachMemberOne.toString(),
        otherTotalVestingTermForEachMemberOne: action.payload.otherTotalVestingTermForEachMemberOne.toString(),
        totalVestingTermForEachMemberTwo: action.payload.totalVestingTermForEachMemberTwo.toString(),
        otherTotalVestingTermForEachMemberTwo: action.payload.otherTotalVestingTermForEachMemberTwo.toString(),
        totalVestingTermForEachMemberThree: action.payload.totalVestingTermForEachMemberThree.toString(),
        otherTotalVestingTermForEachMemberThree: action.payload.otherTotalVestingTermForEachMemberThree.toString(),
        totalVestingTermForEachMemberFour: action.payload.totalVestingTermForEachMemberFour.toString(),
        otherTotalVestingTermForEachMemberFour: action.payload.otherTotalVestingTermForEachMemberFour.toString(),
        vestingIncrementForAllMember: action.payload.vestingIncrementForAllMember.toString(),
        vestingIncrementForMemberOne: action.payload.vestingIncrementForMemberOne.toString(),
        vestingIncrementForMemberTwo: action.payload.vestingIncrementForMemberTwo.toString(),
        vestingIncrementForMemberThree: action.payload.vestingIncrementForMemberThree.toString(),
        vestingIncrementForMemberFour: action.payload.vestingIncrementForMemberFour.toString(),
        




        allMemberAreParticipatingInTheManagement: action.payload.allMemberAreParticipatingInTheManagement.toString(),
        nonManagingMemberStillBeProvidingServices: action.payload.nonManagingMemberStillBeProvidingServices.toString(),
        membersNotExpectedToHaveManagerAuthority: action.payload.membersNotExpectedToHaveManagerAuthority.toString(),
        expectedTimeCommitment: [action.payload.isEachMemberExpectedTimeCommitmentFullTime, action.payload.isEachMemberExpectedTimeCommitmentPartTime, action.payload.isEachMemberExpectedTimeCommitmentNeededToRunCompany, action.payload.isEachMemberExpectedTimeCommitmentOther],
        otherEachMemberExpectedTimeCommitment: action.payload.otherEachMemberExpectedTimeCommitment,
        memberGetSalary: action.payload.memberGetSalary,
        otherMemberGetSalary: action.payload.otherMemberGetSalary,
        isCoMemberHaveApprovalRight: action.payload.isCoMemberHaveApprovalRight,
        coMemberApprovalThreshold: action.payload.coMemberApprovalThreshold,
        coMemberApproval: [
          action.payload.isEnterIntoAnyTransaction,
          action.payload.isEnterIntoAnyCustomerEngagements,
          action.payload.isApproveDistributionOfAnyProfit,
          action.payload.isSetTheAmountAndTermsOfAnyMemberSalary,
          action.payload.isAppointOrRemoveAnyOfficers,
          action.payload.isHireOrTerminateAnyEmployee,
          action.payload.isIssueAnyNewUnitOrAdmitAnyNewMember,
          action.payload.isApproveTheTransferOfAnyUnits,
          action.payload.isChangeTheBankAccount,
          action.payload.isSignNewLease,
          action.payload.isApproveSale,
          action.payload.isFileOrSettleAnyLawsuit,
          action.payload.isDissolveLiquidateOrWindUp,
          action.payload.isTakeAnyOtherMaterialActionOutside,
          action.payload.isAmendTheOperatingAgreement,
          action.payload.isOtherCoMemberApprovalRequiredTo,
        ],
        otherCoMemberApprovalRequiredTo: action.payload.otherCoMemberApprovalRequiredTo,
        limitOnTransactionsBeforeCoMemberApprovalIsRequired: action.payload.limitOnTransactionsBeforeCoMemberApprovalIsRequired,
        limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired: action.payload.limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired,
        isIncludeManagementDeadlockProcedures: action.payload.isIncludeManagementDeadlockProcedures,
        managementDeadlockResolutionYouLike: action.payload.managementDeadlockResolutionYouLike,
        deadlockVoteThreshold: action.payload.deadlockVoteThreshold,
        shouldMemberAbleToBeRemoved: action.payload.shouldMemberAbleToBeRemoved,
        voteThresholdYouWantToRemoveForCauseOrIncapacity: action.payload.voteThresholdYouWantToRemoveForCauseOrIncapacity,
        otherVoteThresholdYouWantToRemoveForCauseOrIncapacity: action.payload.otherVoteThresholdYouWantToRemoveForCauseOrIncapacity,
        voteThresholdYouWantToRemoveWithoutCause: action.payload.voteThresholdYouWantToRemoveWithoutCause,
        otherVoteThresholdYouWantToRemoveWithoutCause: action.payload.otherVoteThresholdYouWantToRemoveWithoutCause,
        shouldTheMemberUnitSubjectToRepurchase: action.payload.shouldTheMemberUnitSubjectToRepurchase,
        howLongOfNoticePeriod: action.payload.howLongOfNoticePeriod,
        otherHowLongOfNoticePeriod: action.payload.otherHowLongOfNoticePeriod,
        isLikeToWaiveTheMemberFiduciaryDuties: action.payload.isLikeToWaiveTheMemberFiduciaryDuties,
        isMemberSubjectToNonCompeteAgreement: action.payload.isMemberSubjectToNonCompeteAgreement,
        isMemberSubjectToNonSolicitationAgreement: action.payload.isMemberSubjectToNonSolicitationAgreement,
        monthsAfterMemberNoLongerWorkingForNonCompete: action.payload.monthsAfterMemberNoLongerWorkingForNonCompete,
        otherMonthsAfterMemberNoLongerWorkingForNonCompete: action.payload.otherMonthsAfterMemberNoLongerWorkingForNonCompete,
        monthsAfterMemberNoLongerWorkingForNonSolicitation: action.payload.monthsAfterMemberNoLongerWorkingForNonSolicitation,
        otherMonthsAfterMemberNoLongerWorkingForNonSolicitation: action.payload.otherMonthsAfterMemberNoLongerWorkingForNonSolicitation,
        monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation: action.payload.monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation,
        otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation: action.payload.otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation,
        




        permittedTransfers: [action.payload.isEstatePlaningTransfers, action.payload.isToHeirsOnDeath, action.payload.isWithMemberApproval, action.payload.isOtherPermittedTransfers],
        toRepurchaseUnits: [action.payload.isFromAMemberWhoHasWithdrawnOrBeenRemoved, action.payload.isAnyImproperlyTransferredUnits, action.payload.isThatHaveBeenTransferredFollowingTheDeathOfAMember, action.payload.isWhenAnyMemberStopsProvidingServicesToTheCompany],
        otherPermittedTransfers: action.payload.otherPermittedTransfers,
        howRepurchasePriceBeDetermined: action.payload.howRepurchasePriceBeDetermined,
        howRepurchasePriceBePaid: action.payload.howRepurchasePriceBePaid,
        howLongTheRepaymentTerm: action.payload.howLongTheRepaymentTerm,
        interestRate: action.payload.interestRate,
        otherInterestRate: action.payload.otherInterestRate,
        offsetAgainstRepurchasePrice: action.payload.offsetAgainstRepurchasePrice,
        preSetDamagesOffset: action.payload.preSetDamagesOffset,
        




        isLLCOperatingAgreementIncludeDefaultDisputeResolution: action.payload.isLLCOperatingAgreementIncludeDefaultDisputeResolution,
        confirmTaxStatus: action.payload.confirmTaxStatus,
        otherInformationNotes: action.payload.otherInformationNotes,
        isSubmitted: action.payload.isSubmitted,
        customerServiceId:action.payload.customerServiceId,
        id:action.payload.id
      } */
      try {
        state.multiMemberLLCData = {
          submissionUpdatesEmail: getStringValue(
            action.payload.submissionUpdatesEmail
          ),
          nameOfLLC: getStringValue(action.payload.nameOfLLC),
          alreadyFiledLLC: getStringValue(action.payload.alreadyFiledLLC),
          mainBusinessAddressLine1: getStringValue(
            action.payload.mainBusinessAddressLine1
          ),
          mainBusinessAddressLine2: getStringValue(
            action.payload.mainBusinessAddressLine2
          ),
          mainBusinessCity: getStringValue(action.payload.mainBusinessCity),
          mainBusinessState: getStringValue(action.payload.mainBusinessState),
          mainBusinessZipCode: getStringValue(
            action.payload.mainBusinessZipCode
          ),
          primaryBusiness: getStringValue(action.payload.primaryBusiness),
          noOfMembers: getStringValue(action.payload.noOfMembers),
          memberOneFirstName: getStringValue(action.payload.memberOneFirstName),
          memberOneInitialName: getStringValue(
            action.payload.memberOneInitialName
          ),
          memberOneLastName: getStringValue(action.payload.memberOneLastName),
          memberOneEmail: getStringValue(action.payload.memberOneEmail),
          memberTwoFirstName: getStringValue(action.payload.memberTwoFirstName),
          memberTwoInitialName: getStringValue(
            action.payload.memberTwoInitialName
          ),
          memberTwoLastName: getStringValue(action.payload.memberTwoLastName),
          memberTwoEmail: getStringValue(action.payload.memberTwoEmail),
          memberThreeFirstName: getStringValue(
            action.payload.memberThreeFirstName
          ),
          memberThreeInitialName: getStringValue(
            action.payload.memberThreeInitialName
          ),
          memberThreeLastName: getStringValue(
            action.payload.memberThreeLastName
          ),
          memberThreeEmail: getStringValue(action.payload.memberThreeEmail),
          memberFourFirstName: getStringValue(
            action.payload.memberFourFirstName
          ),
          memberFourInitialName: getStringValue(
            action.payload.memberFourInitialName
          ),
          memberFourLastName: getStringValue(action.payload.memberFourLastName),
          memberFourEmail: getStringValue(action.payload.memberFourEmail),
          ownershipPercentage: getStringValue(
            action.payload.ownershipPercentage
          ),
          memberOnePercentage: getStringValue(
            action.payload.memberOnePercentage
          ),
          memberTwoPercentage: getStringValue(
            action.payload.memberTwoPercentage
          ),
          memberThreePercentage: getStringValue(
            action.payload.memberThreePercentage
          ),
          memberFourPercentage: getStringValue(
            action.payload.memberFourPercentage
          ),
          expectToAddNewMembers: getStringValue(
            action.payload.expectToAddNewMembers
          ),
          expectationToAddNewMembers: getStringValue(
            action.payload.expectationToAddNewMembers
          ),
          memberOneContribution: [
            action.payload.memberOneIsCash,
            action.payload.memberOneIsService,
            action.payload.memberOneIsPreExistingIntellectualProperty,
            action.payload.memberOneIsOtherAssets,
            action.payload.memberOneIsOther,
          ],
          memberOneOther: getStringValue(action.payload.memberOneOther),
          memberOneCashContribution: getStringValue(
            action.payload.memberOneCashContribution
          ),
          memberOnePreExistingIntellectualProperty: getStringValue(
            action.payload.memberOnePreExistingIntellectualProperty
          ),
          memberOneOtherAssets: getStringValue(
            action.payload.memberOneOtherAssets
          ),
          memberOneIsIntellectualProperty: getStringValue(
            action.payload.memberOneIsIntellectualProperty
          ),
          memberOneIntellectualProperty: getStringValue(
            action.payload.memberOneIntellectualProperty
          ),

          memberTwoContribution: [
            action.payload.memberTwoIsCash,
            action.payload.memberTwoIsService,
            action.payload.memberTwoIsPreExistingIntellectualProperty,
            action.payload.memberTwoIsOtherAssets,
            action.payload.memberTwoIsOther,
          ],
          memberTwoOther: getStringValue(action.payload.memberTwoOther),
          memberTwoCashContribution: getStringValue(
            action.payload.memberTwoCashContribution
          ),
          memberTwoPreExistingIntellectualProperty: getStringValue(
            action.payload.memberTwoPreExistingIntellectualProperty
          ),
          memberTwoOtherAssets: getStringValue(
            action.payload.memberTwoOtherAssets
          ),
          memberTwoIsIntellectualProperty: getStringValue(
            action.payload.memberTwoIsIntellectualProperty
          ),
          memberTwoIntellectualProperty: getStringValue(
            action.payload.memberTwoIntellectualProperty
          ),

          memberThreeContribution: [
            action.payload.memberThreeIsCash,
            action.payload.memberThreeIsService,
            action.payload.memberThreeIsPreExistingIntellectualProperty,
            action.payload.memberThreeIsOtherAssets,
            action.payload.memberThreeIsOther,
          ],
          memberThreeOther: getStringValue(action.payload.memberThreeOther),
          memberThreeCashContribution: getStringValue(
            action.payload.memberThreeCashContribution
          ),
          memberThreePreExistingIntellectualProperty: getStringValue(
            action.payload.memberThreePreExistingIntellectualProperty
          ),
          memberThreeOtherAssets: getStringValue(
            action.payload.memberThreeOtherAssets
          ),
          memberThreeIsIntellectualProperty: getStringValue(
            action.payload.memberThreeIsIntellectualProperty
          ),
          memberThreeIntellectualProperty: getStringValue(
            action.payload.memberThreeIntellectualProperty
          ),

          memberFourContribution: [
            action.payload.memberFourIsCash,
            action.payload.memberFourIsService,
            action.payload.memberFourIsPreExistingIntellectualProperty,
            action.payload.memberFourIsOtherAssets,
            action.payload.memberFourIsOther,
          ],
          memberFourOther: getStringValue(action.payload.memberFourOther),
          memberFourCashContribution: getStringValue(
            action.payload.memberFourCashContribution
          ),
          memberFourPreExistingIntellectualProperty: getStringValue(
            action.payload.memberFourPreExistingIntellectualProperty
          ),
          memberFourOtherAssets: getStringValue(
            action.payload.memberFourOtherAssets
          ),
          memberFourIsIntellectualProperty: getStringValue(
            action.payload.memberFourIsIntellectualProperty
          ),
          memberFourIntellectualProperty: getStringValue(
            action.payload.memberFourIntellectualProperty
          ),
          haveOneOrMoreMemberUnitsSubjectToVesting: getStringValue(
            action.payload.haveOneOrMoreMemberUnitsSubjectToVesting
          ),
          membersHaveTheSameVestingSchedule: getStringValue(
            action.payload.membersHaveTheSameVestingSchedule
          ),
          anyMemberHaveSomePortionOfUnitsVestedImmediately: getStringValue(
            action.payload.anyMemberHaveSomePortionOfUnitsVestedImmediately
          ),
          portionOfTheMemberUnitsNotSubjectToVesting: getStringValue(
            action.payload.portionOfTheMemberUnitsNotSubjectToVesting
          ),
          percentageOfTheMemberUnitsNotSubjectToVesting: getStringValue(
            action.payload.percentageOfTheMemberUnitsNotSubjectToVesting
          ),
          otherPercentageOfTheMemberUnitsNotSubjectToVesting: getStringValue(
            action.payload.otherPercentageOfTheMemberUnitsNotSubjectToVesting
          ),
          memberOneUnitsVestedImmediately: getStringValue(
            action.payload.memberOneUnitsVestedImmediately
          ),
          percentageOfMemberOneUnitsNotSubjectToVesting: getStringValue(
            action.payload.percentageOfMemberOneUnitsNotSubjectToVesting
          ),
          otherPercentageOfMemberOneUnitsNotSubjectToVesting: getStringValue(
            action.payload.otherPercentageOfMemberOneUnitsNotSubjectToVesting
          ),
          memberTwoUnitsVestedImmediately: getStringValue(
            action.payload.memberTwoUnitsVestedImmediately
          ),
          percentageOfMemberTwoUnitsNotSubjectToVesting: getStringValue(
            action.payload.percentageOfMemberTwoUnitsNotSubjectToVesting
          ),
          otherPercentageOfMemberTwoUnitsNotSubjectToVesting: getStringValue(
            action.payload.otherPercentageOfMemberTwoUnitsNotSubjectToVesting
          ),
          memberThreeUnitsVestedImmediately: getStringValue(
            action.payload.memberThreeUnitsVestedImmediately
          ),
          percentageOfMemberThreeUnitsNotSubjectToVesting: getStringValue(
            action.payload.percentageOfMemberThreeUnitsNotSubjectToVesting
          ),
          otherPercentageOfMemberThreeUnitsNotSubjectToVesting: getStringValue(
            action.payload.otherPercentageOfMemberThreeUnitsNotSubjectToVesting
          ),
          memberFourUnitsVestedImmediately: getStringValue(
            action.payload.memberFourUnitsVestedImmediately
          ),
          percentageOfMemberFourUnitsNotSubjectToVesting: getStringValue(
            action.payload.percentageOfMemberFourUnitsNotSubjectToVesting
          ),
          otherPercentageOfMemberFourUnitsNotSubjectToVesting: getStringValue(
            action.payload.otherPercentageOfMemberFourUnitsNotSubjectToVesting
          ),
          totalVestingTermForEachMember: getStringValue(
            action.payload.totalVestingTermForEachMember
          ),
          otherTotalVestingTermForEachMember: getStringValue(
            action.payload.otherTotalVestingTermForEachMember
          ),
          totalVestingTermForEachMemberOne: getStringValue(
            action.payload.totalVestingTermForEachMemberOne
          ),
          otherTotalVestingTermForEachMemberOne: getStringValue(
            action.payload.otherTotalVestingTermForEachMemberOne
          ),
          totalVestingTermForEachMemberTwo: getStringValue(
            action.payload.totalVestingTermForEachMemberTwo
          ),
          otherTotalVestingTermForEachMemberTwo: getStringValue(
            action.payload.otherTotalVestingTermForEachMemberTwo
          ),
          totalVestingTermForEachMemberThree: getStringValue(
            action.payload.totalVestingTermForEachMemberThree
          ),
          otherTotalVestingTermForEachMemberThree: getStringValue(
            action.payload.otherTotalVestingTermForEachMemberThree
          ),
          totalVestingTermForEachMemberFour: getStringValue(
            action.payload.totalVestingTermForEachMemberFour
          ),
          otherTotalVestingTermForEachMemberFour: getStringValue(
            action.payload.otherTotalVestingTermForEachMemberFour
          ),
          vestingIncrementForAllMember: getStringValue(
            action.payload.vestingIncrementForAllMember
          ),
          vestingIncrementForMemberOne: getStringValue(
            action.payload.vestingIncrementForMemberOne
          ),
          vestingIncrementForMemberTwo: getStringValue(
            action.payload.vestingIncrementForMemberTwo
          ),
          vestingIncrementForMemberThree: getStringValue(
            action.payload.vestingIncrementForMemberThree
          ),
          vestingIncrementForMemberFour: getStringValue(
            action.payload.vestingIncrementForMemberFour
          ),

          /* <------------------------------Step2---------------------------> */
          allMemberAreParticipatingInTheManagement: getStringValue(
            action.payload.allMemberAreParticipatingInTheManagement
          ),
          nonManagingMemberStillBeProvidingServices: getStringValue(
            action.payload.nonManagingMemberStillBeProvidingServices
          ),
          membersNotExpectedToHaveManagerAuthority: getStringValue(
            action.payload.membersNotExpectedToHaveManagerAuthority
          ),

          expectedTimeCommitment: [
            action.payload.isEachMemberExpectedTimeCommitmentFullTime,
            action.payload.isEachMemberExpectedTimeCommitmentPartTime,
            action.payload.isEachMemberExpectedTimeCommitmentNeededToRunCompany,
            action.payload.isEachMemberExpectedTimeCommitmentOther,
          ],
          otherEachMemberExpectedTimeCommitment: getStringValue(
            action.payload.otherEachMemberExpectedTimeCommitment
          ),
          memberGetSalary: getStringValue(action.payload.memberGetSalary),
          otherMemberGetSalary: getStringValue(
            action.payload.otherMemberGetSalary
          ),
          isCoMemberHaveApprovalRight: getStringValue(
            action.payload.isCoMemberHaveApprovalRight
          ),
          coMemberApprovalThreshold: getStringValue(
            action.payload.coMemberApprovalThreshold
          ),
          coMemberApproval: [
            action.payload.isEnterIntoAnyTransaction,
            action.payload.isEnterIntoAnyCustomerEngagements,
            action.payload.isApproveDistributionOfAnyProfit,
            action.payload.isSetTheAmountAndTermsOfAnyMemberSalary,
            action.payload.isAppointOrRemoveAnyOfficers,
            action.payload.isHireOrTerminateAnyEmployee,
            action.payload.isIssueAnyNewUnitOrAdmitAnyNewMember,
            action.payload.isApproveTheTransferOfAnyUnits,
            action.payload.isChangeTheBankAccount,
            action.payload.isSignNewLease,
            action.payload.isApproveSale,
            action.payload.isFileOrSettleAnyLawsuit,
            action.payload.isDissolveLiquidateOrWindUp,
            action.payload.isTakeAnyOtherMaterialActionOutside,
            action.payload.isAmendTheOperatingAgreement,
            action.payload.isOtherCoMemberApprovalRequiredTo,
          ],
          otherCoMemberApprovalRequiredTo: getStringValue(
            action.payload.otherCoMemberApprovalRequiredTo
          ),
          limitOnTransactionsBeforeCoMemberApprovalIsRequired: getStringValue(
            action.payload.limitOnTransactionsBeforeCoMemberApprovalIsRequired
          ),
          limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired:
            getStringValue(
              action.payload
                .limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired
            ),
          isIncludeManagementDeadlockProcedures: getStringValue(
            action.payload.isIncludeManagementDeadlockProcedures
          ),
          managementDeadlockResolutionYouLike: getStringValue(
            action.payload.managementDeadlockResolutionYouLike
          ),
          deadlockVoteThreshold: getStringValue(
            action.payload.deadlockVoteThreshold
          ),
          shouldMemberAbleToBeRemoved: getStringValue(
            action.payload.shouldMemberAbleToBeRemoved
          ),
          voteThresholdYouWantToRemoveForCauseOrIncapacity: getStringValue(
            action.payload.voteThresholdYouWantToRemoveForCauseOrIncapacity
          ),
          otherVoteThresholdYouWantToRemoveForCauseOrIncapacity: getStringValue(
            action.payload.otherVoteThresholdYouWantToRemoveForCauseOrIncapacity
          ),
          voteThresholdYouWantToRemoveWithoutCause: getStringValue(
            action.payload.voteThresholdYouWantToRemoveWithoutCause
          ),
          otherVoteThresholdYouWantToRemoveWithoutCause: getStringValue(
            action.payload.otherVoteThresholdYouWantToRemoveWithoutCause
          ),
          shouldTheMemberUnitSubjectToRepurchase: getStringValue(
            action.payload.shouldTheMemberUnitSubjectToRepurchase
          ),
          howLongOfNoticePeriod: getStringValue(
            action.payload.howLongOfNoticePeriod
          ),
          otherHowLongOfNoticePeriod: getStringValue(
            action.payload.otherHowLongOfNoticePeriod
          ),
          isLikeToWaiveTheMemberFiduciaryDuties: getStringValue(
            action.payload.isLikeToWaiveTheMemberFiduciaryDuties
          ),
          isMemberSubjectToNonCompeteAgreement: getStringValue(
            action.payload.isMemberSubjectToNonCompeteAgreement
          ),
          isMemberSubjectToNonSolicitationAgreement: getStringValue(
            action.payload.isMemberSubjectToNonSolicitationAgreement
          ),
          monthsAfterMemberNoLongerWorkingForNonCompete: getStringValue(
            action.payload.monthsAfterMemberNoLongerWorkingForNonCompete
          ),
          otherMonthsAfterMemberNoLongerWorkingForNonCompete: getStringValue(
            action.payload.otherMonthsAfterMemberNoLongerWorkingForNonCompete
          ),
          monthsAfterMemberNoLongerWorkingForNonSolicitation: getStringValue(
            action.payload.monthsAfterMemberNoLongerWorkingForNonSolicitation
          ),
          otherMonthsAfterMemberNoLongerWorkingForNonSolicitation:
            getStringValue(
              action.payload
                .otherMonthsAfterMemberNoLongerWorkingForNonSolicitation
            ),
          monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
            getStringValue(
              action.payload
                .monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation
            ),
          otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
            getStringValue(
              action.payload
                .otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation
            ),
          /* <-----------------------Step3----------------------------------------> */
          permittedTransfers: [
            action.payload.isEstatePlaningTransfers,
            action.payload.isToHeirsOnDeath,
            action.payload.isWithMemberApproval,
            action.payload.isOtherPermittedTransfers,
          ],
          toRepurchaseUnits: [
            action.payload.isFromAMemberWhoHasWithdrawnOrBeenRemoved,
            action.payload.isAnyImproperlyTransferredUnits,
            action.payload.isThatHaveBeenTransferredFollowingTheDeathOfAMember,
            action.payload.isWhenAnyMemberStopsProvidingServicesToTheCompany,
          ],
          otherPermittedTransfers: getStringValue(
            action.payload.otherPermittedTransfers
          ),
          howRepurchasePriceBeDetermined: getStringValue(
            action.payload.howRepurchasePriceBeDetermined
          ),
          howRepurchasePriceBePaid: getStringValue(
            action.payload.howRepurchasePriceBePaid
          ),
          howLongTheRepaymentTerm: getStringValue(
            action.payload.howLongTheRepaymentTerm
          ),
          interestRate: getStringValue(action.payload.interestRate),
          otherInterestRate: getStringValue(action.payload.otherInterestRate),
          offsetAgainstRepurchasePrice: getStringValue(
            action.payload.offsetAgainstRepurchasePrice
          ),
          preSetDamagesOffset: getStringValue(
            action.payload.preSetDamagesOffset
          ),

          /* <-----------------------Step4----------------------------------------> */
          isLLCOperatingAgreementIncludeDefaultDisputeResolution:
            getStringValue(
              action.payload
                .isLLCOperatingAgreementIncludeDefaultDisputeResolution
            ),
          confirmTaxStatus: getStringValue(action.payload.confirmTaxStatus),
          otherInformationNotes: getStringValue(
            action.payload.otherInformationNotes
          ),
          isSubmitted: action.payload.isSubmitted,
          customerServiceId: action.payload.customerServiceId,
          id: action.payload.id,
        };
      } catch (error) {
        debugger;
        console.log(
          "An error occurred while setting multiMemberLLCData:",
          error
        );
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setStep,
  setmultiMemberLLCDataStep1,
  setmultiMemberLLCDataStep2,
  setmultiMemberLLCDataStep3,
  setmultiMemberLLCDataStep4,
  setCustomerServiceId,
  setmultiMemberLLCData,
} = multiMemberLLCSlice.actions;

export default multiMemberLLCSlice.reducer;
